import { useEffect, useState } from "react";
import { FactureEmise, InvoiceData, UserInfos } from "../../redux/types";
import { computeDashboardTotals } from "../dashboard-totals";

export function useDashboard(
  users: UserInfos[],
  invoices: InvoiceData[],
  factures: FactureEmise[]
) {
  const [data, setData] = useState({
    total_tva_emise: 0,
    total_tva_recuperable: 0,
    total_facture_emise: 0,
    total_facture_depense: 0,
    total_user_count: 0,
    total_facture_count: 0,
  });

  useEffect(() => {
    // Calcul partagé avec l'espace comptable (utils/dashboard-totals.ts).
    const totals = computeDashboardTotals(invoices, factures);
    setData({
      ...totals,
      total_user_count: users.filter((f) => !!f.email_comptable).length,
      total_facture_count: invoices.length,
    });
    // Dépendre des TABLEAUX et non de leur longueur : un changement de statut
    // (une facture qui passe « rejetée par la plateforme ») ne modifie aucun
    // compteur, et les totaux restaient figés. Les tableaux viennent de
    // sélecteurs Redux, donc de références stables : pas de boucle de rendu.
  }, [users, invoices, factures]);

  return {
    data,
    loading: data.total_facture_count === 0,
  };
}
